module.exports = __webpack_public_path__ + "static/media/directions_en@3x.d1f36916.png";